import { Validator } from "../../../TOOLS/Validator";
import { FormController } from "./FormController";

export class NewUserForm {

    constructor(store) {
        this.store = store;
        this.validator = new Validator(this.store);
        this.formController = new FormController(this.store, this.validator);
        this.container = document.createElement("div");
        this.container.className = 'width-100 height-100';
        this.container.id = 'NEWUSERFORM MAIN';
        this.formObject = {email: "", picture: "", id: 0, officeid: 0, inventory: "", token: "", districtid: 0, name: "", role: "", tokentimestamp: "", firestoreid: "", job: ""}
        this.excludedFields = [
            "id",
            "firestoreid",
            "picture",
            "district",
            "inventory",
            "districtid",
            "role",
            "token",
            "tokentimestamp",
        ];
        this.keyChange = {
            email: "e-mail",
            name: "Név",
            job: "Munkakör",
            officeid: "Iroda",
        };
        this.officeRolldown = [];
        this.selectedOffice = null;
    }

    async render() {
        await this.buildRolldowns()
        this.container.innerHTML = "";
        this.container.appendChild(this.renderForm());
        return this.container;
    }

    renderForm() {
        const form = document.createElement("form");
        form.className = "sectionColumn";
        form.id = 'FORMSECTION'
        const headerWrapper = document.createElement("div");
        headerWrapper.className = "wrapper width-100 row border-bottom margin-bottom-1 padding-left-1 padding-right-1 padding-top-2 padding-bottom-2";
        headerWrapper.id = 'HEADWRAPPER'
        const title = document.createElement("div");
        title.className = "font-30 weight-600 color-50";
        title.textContent = "ÚJ KOLLÉGA";
        headerWrapper.appendChild(title);
        form.appendChild(headerWrapper);
        Object.entries(this.formObject)
        .filter(([key]) => {
            if (!this.excludedFields.includes(key)) {return true;}
            return false;
        })
        .forEach(([key, value]) => {
            const row = document.createElement("div");
            row.className = "list-row";
            const label = document.createElement("label");
            label.textContent = this.keyChange[key] ?? key;
            row.appendChild(label);
            let field;
            if (key === "officeid") {
                field = document.createElement("select");
                field.className = 'form-input'
                field.name = key;
                field.addEventListener("change", () => {this.selectedOffice = Number(field.value);});
                this.officeRolldown.forEach(office => {
                    const option = document.createElement("option");
                    option.value = office.officeid;
                    option.textContent = office.name;
                    if (office.officeid === value) {
                        option.selected = true;  
                        this.selectedOffice = office.officeid;
                    }
                    field.appendChild(option);
                });
            }else if (key === "job") {
                field = document.createElement("input");
                field.className = 'form-input'
                field.type = "checkbox";
                field.name = key;
                field.id = "job-switch";
                field.checked = value === "HO";
                const wrapper = document.createElement("div");
                wrapper.className = "job-switch-wrapper";
                const left = document.createElement("span");
                left.className = "job-label";
                left.textContent = "FALUGAZDÁSZ";
                const switchLabel = document.createElement("label");
                switchLabel.className = "switch";
                const slider = document.createElement("span");
                slider.className = "slider";
                switchLabel.appendChild(field);
                switchLabel.appendChild(slider);
                const right = document.createElement("span");
                right.className = "job-label";
                right.textContent = "IRODAI DOLGOZÓ";
                wrapper.appendChild(left);
                wrapper.appendChild(switchLabel);
                wrapper.appendChild(right);
                row.appendChild(wrapper);
                form.appendChild(row);
                return;
            }
            else {
                field = document.createElement("input");
                field.className = 'form-input'
                field.name = key;
                field.type = typeof value === "number" ? "number" : "text";
                field.value = value ?? "";
            }
            row.appendChild(field);
            form.appendChild(row);
        });

        const button = document.createElement("div");
        button.className = 'width-100 justify-center margin-top-2 login-button'
        button.type = "submit";
        form.appendChild(button);
        this.bindItemEvents(button, form);
        return form
    }

    bindItemEvents(button, form) {
        button.addEventListener("click", async (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.formController.bindSubmit(form, {
                getData: this.getData.bind(this),
                complete: this.complete.bind(this),
                process: "SAVE",
                formType: "USER",
                original: this.formObject,
                reference: "USERS",
                logtype: "SAVE",
                onSuccess: async (response) => {this.store.levelController.setLevel({name: "MAP", office: null, position: null});
                    this.store.toast.success(response);
                }
            });
            form.requestSubmit();
        });
    }

    async buildRolldowns() {this.officeRolldown = await this.store.datas.getOfficeRolldownByDistrict(this.store.level.selectedDistrict)}

    getData(form) {
        const result = { ...this.formObject };
        Array.from(form.elements).forEach(element => {
            if (!element.name) return;
            if (element.name === "job") {result.job = element.checked ? "HO" : "FG";
            }else if (element.name === "officeid") {result.officeid = Number(element.value);
            } else {result[element.name] = element.type === "number" ? Number(element.value) : element.value;}
        });
        return result;
    }


    async complete(data) {
        let district = await this.store.datas.findOne('CITIES', 'district', this.store.level.selectedOffice.district);
        data.districtid = parseInt(district.districtid)
        data.role = 'active';
        data.inventory = 'inactive';
        return data    
    }

}